<template>
  <div>
    <b-container>
      <CDNDoc></CDNDoc>
      <CustomCDN></CustomCDN>
    </b-container>
  </div>
</template>

<script>
import CDNDoc from "@/components/documentation/CDNDoc.vue";
import CustomCDN from "@/components/CustomCDN.vue";

export default {
  name: "PluginCDN",
  components: {
    CustomCDN,
    CDNDoc,
  },
};
</script>
